import Vue from "vue";

/**
 * 이벤트 허브로 이용함 비부모간 컨포넌트 끼리 통신가능
 */
const eventHub = new Vue();
/**
 * mixin 기본기능
 */
export default {
  data: () => ({
    eventHub: eventHub,
  }),
  methods: {
    /**
     * 기본 얼럿 메시지 노출
     * @param {string} msg
     */
    alertShow: function(msg, time = 3000) {
      this.$store.state.alert.display = true;
      this.$store.state.alert.msg = msg;
      setTimeout(() => {
        this.$store.state.alert.display = false;
        this.$store.state.alert.msg = "";
      }, time);
    },
    /**
     * 얼럿 숨김
     */
    alertHide: function() {
      this.$store.state.alert.display = false;
      this.$store.state.alert.msg = "";
    },
    /**
     * 기본 progress
     */
    defaultProgressShow: function() {
      this.$store.state.progressDisplay = true;
    },
    /**
     * 기본 progress 숨김
     */
    defaultProgressHide: function() {
      this.$store.state.progressDisplay = false;
    },
    circularProgressShow: function(html) {
      this.$store.state.circularProgress.html = html;
      this.$store.state.circularProgress.display = true;
      this.$store.state.circularProgress.value = 0;
    },
    circularProgressSetValue: function(val) {
      val = !isNaN(val) ? val : 0;
      val = val > 100 ? 100 : val;
      this.$store.state.circularProgress.value = val;
    },
    circularProgressHide: function() {
      this.$store.state.circularProgress.html = "";
      this.$store.state.circularProgress.display = false;
    },
    moveEcOrderPage: function(order_id) {
      let domain = `https://${this.$store.state.mallId}.cafe24.com/admin/php/shop${this.$store.state.shopNo}/s_new/order_detail.php?`;
      let params = `order_id=${order_id}`;
      return domain + params;
    },
    moveEcUserPage: function(userId) {
      if (this.$store.state.mallType !== "imweb") {
        let domain = `https://${this.$store.state.mallId}.cafe24.com/admin/php/shop${this.$store.state.shopNo}/c/member_admin_d_f.php?`;
        let params = `user_id=${userId}`;
        return domain + params;
      } else {
        let shopurl = this.getAdminUrl();
        // https://surpinghelp.imweb.me/admin/member/list/?mc=m20250502b4a4d56b2ad1a&keyword=nana.lim@coggiri.com
        return `https://${shopurl}/admin/member/list?&keyword=${userId}`;
      }
    },
    getAdminUrl: function() {
      return sessionStorage.getItem(`${this.$store.state.mallId}_domain`);
    },
    getSampleData: () => {
      return {
        "#{USER_NAME}": "홍길동",
        "#{USER_ID}": "test123",
        "#{USER_EMAIL}": "test123@sample.com",
        "#{ORDER_DATE}": "2024-12-25 12:25:23",
        "#{ORDER_NAME}": "홍길동",
        "#{ORDER_NO}": "20990517-0000001",
        "#{ORDER_PRICE}": "10,000",
        "#{SHOP_NAME}": "쇼핑몰명",
        "#{PRODUCT_NAME}": "테스트상품명",
        "#{PRODUCT_CODE}": "P0000ABC",
        "#{SERIAL_CODE}": "ABCD-AC83-U17P-1234",
        "#{REGISTRATION_URL}": "https://쇼핑몰도메인/registration/index.html",
        "#{REGISTRATION_PERIOD}": "2025-01-01 ~ 2027-01-01",
        "#{CERT_INPUT_NAME}": "홍길동",
        "#{CERT_INPUT_EMAIL}": "test123@sample.com",
        "#{CERT_INPUT_PHONE}": "010-1234-5678",
        "#{CERT_PRODUCT_NAME}": "테스트상품명",
        "#{CERT_SERIAL_CODE}": "ABCD-AC83-U17P-U4YS",
        "#{AS_INPUT_NAME}": "홍길동",
        "#{AS_INPUT_EMAIL}": "test123@sample.com",
        "#{AS_INPUT_PHONE}": "010-1234-5678",
        "#{AS_PRODUCT_NAME}": "테스트상품명",
        "#{AS_SERIAL_CODE}": "AS-AC83-U17P-1234",
        "#{AS_REPAIR_AMOUNT}": "15000",
        "#{AS_TRACKING_NO}": "1234-5678-9012",
      };
    },
    getIsOrderMessage: (msg_type) => {
      const order_group = [
        "payment_end",
        "shipping_start",
        "shipping_end",
        "buyed_confirm",
        "cancel_start",
        "cancel_end",
        "exchange_start",
        "exchange_end",
        "refund_start",
        "refund_end",
      ];
      return order_group.includes(msg_type);
    },
    getAbleSerialTag: (msg_type) => {
      const serial_group = ["buyed_confirm", "shipping_end"];
      return serial_group.includes(msg_type);
    },
    isManualMessage: (msg_type) => {
      return ["template_1", "template_2", "template_3", "template_4", "template_5"].includes(msg_type);
    },
    isAsMessage: (msg_type) => {
      return ["receipt_start", "receipt_done", "center_in", "payment_waiting", "payment_done", "as_done", "shipping_done", "done"].includes(
        msg_type,
      );
    },
    getUserTagList: function(is_order = true, is_serial_tag = false) {
      const user_tags = [
        {
          text: "#{USER_NAME}",
          desc: "회원 이름",
        },
        {
          text: "#{USER_ID}",
          desc: "회원 아이디",
        },
        {
          text: "#{USER_EMAIL}",
          desc: "회원 이메일",
        },
        {
          text: "#{SHOP_NAME}",
          desc: "쇼핑몰명",
        },
        {
          text: "#{PRODUCT_NAME}",
          desc: "상품명",
        },
        {
          text: "#{PRODUCT_CODE}",
          desc: "상품코드",
        },
      ];
      if (this.isAsMessage(this.msg_type)) {
        return [
          {
            text: "#{SHOP_NAME}",
            desc: "쇼핑몰명",
          },
          {
            text: "#{AS_INPUT_NAME}",
            desc: "AS 신청시 입력 이름",
          },
          {
            text: "#{AS_INPUT_EMAIL}",
            desc: "AS 신청시 입력 이메일",
          },
          {
            text: "#{AS_INPUT_PHONE}",
            desc: "AS 신청시 입력 핸드폰",
          },
          {
            text: "#{AS_PRODUCT_NAME}",
            desc: "AS 신청한 상품명",
          },
          {
            text: "#{AS_SERIAL_CODE}",
            desc: "AS 신청한 시리얼번호",
          },
          {
            text: "#{AS_REPAIR_AMOUNT}",
            desc: "AS 수리 금액",
          },
          {
            text: "#{AS_TRACKING_NO}",
            desc: "AS 발송 운송장번호",
          },
        ];
      }
      if (this.$store.state.appCode !== "cert_digital") {
        user_tags.push({
          text: "#{REGISTRATION_URL}",
          desc: "정품인증페이지",
        });
      }

      if (is_order) {
        user_tags.push(
          {
            text: "#{ORDER_DATE}",
            desc: "주문일",
          },
          {
            text: "#{ORDER_NAME}",
            desc: "주문자명",
          },
          {
            text: "#{ORDER_NO}",
            desc: "주문번호",
          },
          {
            text: "#{ORDER_PRICE}",
            desc: "주문금액",
          },
        );
        if (is_serial_tag) {
          user_tags.push({
            text: "#{SERIAL_CODE}",
            desc: "시리얼코드 (미인증 코드 발송)",
          });
        }
      } else {
        user_tags.push(
          {
            text: "#{REGISTRATION_PERIOD}",
            desc: "보증 기간",
          },
          {
            text: "#{CERT_INPUT_NAME}",
            desc: "인증시 입력 이름",
          },
          {
            text: "#{CERT_INPUT_EMAIL}",
            desc: "인증시 입력 이메일",
          },
          {
            text: "#{CERT_INPUT_PHONE}",
            desc: "인증시 입력 전화번호",
          },
          {
            text: "#{CERT_PRODUCT_NAME}",
            desc: "인증 상품명",
          },
          {
            text: "#{CERT_SERIAL_CODE}",
            desc: "인증 시리얼코드",
          },
        );
      }
      return user_tags;
    },
    getInitContentText: function(msg_type) {
      switch (msg_type) {
        case "template_1":
        case "template_2":
        case "template_3":
        case "template_4":
        case "template_5":
          return "";
        case "payment_end":
          return "#{SHOP_NAME} \n#{ORDER_NAME} 님, 결제완료 되었습니다.\n주문일 : #{ORDER_DATE}\n주문번호 : #{ORDER_NO}\n주문상품 : #{PRODUCT_NAME}\n배송완료 후 정품 인증을 받으세요.";
        case "shipping_start":
          return "#{SHOP_NAME}\n#{ORDER_NAME} 님, 제품이 발송되었습니다.\n주문번호 : #{ORDER_NO}\n주문상품 : #{PRODUCT_NAME}\n배송완료 후 정품 인증을 받으세요.";
        case "shipping_end":
          if (this.$store.state.appCode === "cert_digital") {
            return "#{SHOP_NAME}\n#{ORDER_NAME} 님,  구매하신 상품의 시리얼 코드를 확인하세요.\n주문번호 : #{ORDER_NO}\n주문상품 : #{PRODUCT_NAME}\n시리얼코드 : #{SERIAL_CODE}";
          } else {
            return "#{SHOP_NAME}\n#{ORDER_NAME} 님,  정품 인증 및 등록을 해주세요.\n주문번호 : #{ORDER_NO}\n주문상품 : #{PRODUCT_NAME}\n정품 인증 하러가기 : #{REGISTRATION_URL}";
          }
        case "buyed_confirm":
          if (this.$store.state.appCode === "cert_digital") {
            return "#{SHOP_NAME}\n#{ORDER_NAME} 님,  구매하신 상품의 시리얼 코드를 확인하세요.\n주문번호 : #{ORDER_NO}\n주문상품 : #{PRODUCT_NAME}\n시리얼코드 : #{SERIAL_CODE}";
          } else {
            return "#{SHOP_NAME}\n#{ORDER_NAME} 님,  정품 인증 및 등록을 해주세요.\n주문번호 : #{ORDER_NO}\n주문상품 : #{PRODUCT_NAME}\n정품 인증 하러가기 : #{REGISTRATION_URL}";
          }
        case "cancel_start":
          return "#{SHOP_NAME}\n#{ORDER_NAME} 님, 취소접수가 되었습니다.\n주문번호 : #{ORDER_NO}\n주문상품 : #{PRODUCT_NAME}\n빠르게 확인 및 조치하도록 하겠습니다. 감사합니다.";
        case "cancel_end":
          return "#{SHOP_NAME}\n#{ORDER_NAME} 님, 취소완료가 되었습니다.\n주문번호 : #{ORDER_NO}\n주문상품 : #{PRODUCT_NAME}\n앞으로 더욱 좋은 서비스를 제공하도록 노력하겠습니다. 감사합니다.";
        case "exchange_start":
          return "#{SHOP_NAME}\n#{ORDER_NAME} 님, 교환접수가 되었습니다.\n주문번호 : #{ORDER_NO}\n주문상품 : #{PRODUCT_NAME}\n빠르게 확인 및 조치하도록 하겠습니다. 감사합니다.";
        case "exchange_end":
          return "#{SHOP_NAME}\n#{ORDER_NAME} 님, 교환완료가 되었습니다.\n주문번호 : #{ORDER_NO}\n주문상품 : #{PRODUCT_NAME}\n앞으로 더욱 좋은 서비스를 제공하도록 노력하겠습니다. 감사합니다.";
        case "refund_start":
          if (this.$store.state.appCode === "cert_digital") {
            return "#{SHOP_NAME}\n#{ORDER_NAME} 님, 반품접수가 되었습니다.\n주문번호 : #{ORDER_NO}\n주문상품 : #{PRODUCT_NAME}\n디지털 상품의 경우 결제와 동시에 시리얼코드가 발송되며\n반품 처리가 되지 않으니 참고해주세요.";
          } else {
            return "#{SHOP_NAME}\n#{ORDER_NAME} 님, 반품접수가 되었습니다.\n주문번호 : #{ORDER_NO}\n주문상품 : #{PRODUCT_NAME}\n빠르게 확인 및 조치하도록 하겠습니다. 감사합니다.";
          }
        case "refund_end":
          if (this.$store.state.appCode === "cert_digital") {
            return "#{SHOP_NAME}\n#{ORDER_NAME} 님, 반품완료가 되었습니다.\n주문번호 : #{ORDER_NO}\n주문상품 : #{PRODUCT_NAME}\n디지털 상품의 경우 결제와 동시에 시리얼코드가 발송되며\n반품 처리가 되지 않으니 참고해주세요.";
          } else {
            return "#{SHOP_NAME}\n#{ORDER_NAME} 님, 반품완료가 되었습니다.\n주문번호 : #{ORDER_NO}\n주문상품 : #{PRODUCT_NAME}\n앞으로 더욱 좋은 서비스를 제공하도록 노력하겠습니다. 감사합니다.";
          }
        case "member_cert_end":
          return "#{SHOP_NAME} \n#{USER_NAME}님, 정품 인증이 완료되었습니다.\n정품 인증 기간 : #{REGISTRATION_PERIOD}\n시리얼 코드 : #{CERT_SERIAL_CODE}";
        case "admin_cert_end":
          return "#{SHOP_NAME} \n관리자에 의해 정품 인증이 완료되었습니다.\n정품 인증 기간 : #{REGISTRATION_PERIOD}\n시리얼 코드 : #{CERT_SERIAL_CODE}";
        case "admin_approval_end":
          return "#{SHOP_NAME} \n관리자에 의해 정품 인증 승인이 완료되었습니다.\n정품 인증 기간 : #{REGISTRATION_PERIOD}\n시리얼 코드 : #{CERT_SERIAL_CODE}";
        case "expired_before":
          return "#{SHOP_NAME} \n정품 보증 기간이 만료 될 예정입니다.\n정품 인증 기간 : #{REGISTRATION_PERIOD}\n시리얼 코드 : #{CERT_SERIAL_CODE}";
        case "expired_after":
          return "#{SHOP_NAME} \n정품 보증 기간이 만료되었습니다.\n정품 인증 기간 : #{REGISTRATION_PERIOD}\n시리얼 코드 : #{CERT_SERIAL_CODE}";
        case "member_cert_cancel":
          return "#{SHOP_NAME} \n정품 인증이 취소되었습니다.\n시리얼 코드 : #{CERT_SERIAL_CODE}";
        case "admin_cert_cancel":
          return "#{SHOP_NAME} \n관리자에 의해 정품 인증이 취소되었습니다.\n시리얼 코드 : #{CERT_SERIAL_CODE}";
        case "member_lost_regist":
          return "#{SHOP_NAME} \n#{USER_NAME}님, 정품 인증하신 상품이 분실 상태로 변경되었습니다.\n분실 상태일 경우 다른 사용자가 정품 인증을 할 수 없으며, 분실된 제품을 제3자가 정품인증을 시도하는 경우 관리자가 확인이 가능합니다.\n제품을 찾으시면 분실 취소로 변경하시길 권장합니다.\n감사합니다.";
        case "admin_lost_regist":
          return "#{SHOP_NAME} \n#{USER_NAME}님, 관리자에 의해 정품 인증하신 상품이 분실 상태로 변경되었습니다.\n분실 상태일 경우 다른 사용자가 정품 인증을 할 수 없으며, 분실된 제품을 제3자가 정품인증을 시도하는 경우 관리자가 확인이 가능합니다.\n제품을 찾으시면 분실 취소로 변경하시길 권장합니다.\n감사합니다.";
        case "member_lost_cancel":
          return "#{SHOP_NAME}\n#{USER_NAME}님, 분실된 제품을 잘 찾으셨나요?\n해당 제품은 정상적인 정품 인증 상태로 변경되었습니다.\n감사합니다.";
        case "lost_3rd_verify_member":
          return "#{SHOP_NAME}\n#{USER_NAME}님, 제3자가 분실 제품 인증을 시도하였습니다.\n관리자 확인하여 안내드리도록 하겠습니다.\n감사합니다.";
        case "lost_3rd_verify_admin":
          return "#{SHOP_NAME}\n제3자가 분실 제품 인증을 시도하였습니다.\n시리얼 코드 : #{CERT_SERIAL_CODE}";
        case "receipt_start":
          return "#{SHOP_NAME} A/S 접수 안내\n고객님의 A/S 신청이 정상적으로 접수되었습니다.\n빠른 시일 내에 담당자 확인 후 추가 안내드리겠습니다.\n감사합니다.";
        case "receipt_done":
          return "#{SHOP_NAME}  A/S 접수 완료 \n신청하신 A/S 건이 확인되어 접수 완료되었습니다. \n감사합니다.";
        case "center_in":
          return "#{SHOP_NAME} 제품 입고 안내 \n보내주신 제품이 서비스 센터에 무사히 도착했습니다. \n전문 엔지니어가 제품 상태를 꼼꼼히 점검할 예정입니다.\n감사합니다.";
        case "payment_waiting":
          return "#{SHOP_NAME} 입금 대기 안내\n점검 결과에 따른 수리 비용 발생으로 입금 확인 후 작업이 진행됩니다.\n금액: #{AS_REPAIR_AMOUNT}원\n감사합니다.";
        case "payment_done":
          return "#{SHOP_NAME} 입금 완료 안내\n신청하신 A/S건의 수리 비용 입금이 확인되었습니다. \n금액: #{AS_REPAIR_AMOUNT}원\n빠르게 A/S 처리하여 발송하도록 하겠습니다.\n감사합니다.";
        case "as_done":
          return "#{SHOP_NAME} 수리 완료 안내\n요청하신 A/S 작업이 모두 완료되었습니다.\n제품은 꼼꼼히 검수하여 안전하게 발송해 드리겠습니다.\n감사합니다.";
        case "shipping_done":
          return "#{SHOP_NAME} 제품 배송 안내\nA/S가 완료된 제품을 발송하였습니다.\n운송장: #{AS_TRACKING_NO}\n감사합니다.";
        case "done":
          return "#{SHOP_NAME} AS 처리 완료\n모든 A/S 절차가 종료되었습니다.\n저희 서비스를 이용해 주셔서 감사합니다.\n이용 중 불편한 점이 있다면 언제든 문의해 주세요.\n감사합니다.";
      }
    },
    isTagUsed: (content, tag) => {
      return content.includes(tag);
    },
    getUseTypeByTag: async (M, tag, msg_type) => {
      try {
        const res = await M.api(M.entry("/get/message/detail/tag_check"), { search_tag: tag });
        if (res.count === 0) {
          return false;
        } else {
          return !res.use_list.includes(msg_type);
        }
      } catch (error) {
        console.error(error);
      }
    },
    isAllowedKakaoForDigital: function() {
      if (this.$store.state.appCode !== "cert_digital") {
        return true;
      } else {
        // cert_digital 앱 코드인 경우 카카오톡 발송이 허용되는지 여부
        const check_ids = ["a"];
        return check_ids.includes(this.$store.state.mallId);
      }
    },
    async waitForShopNo(timeout = 5000) {
      return new Promise((resolve, reject) => {
        if (this.$store.state.shopNo) {
          resolve(this.$store.state.shopNo);
          return;
        }

        const checkInterval = setInterval(() => {
          if (this.$store.state.shopNo) {
            clearInterval(checkInterval);
            clearTimeout(timeoutId);
            resolve(this.$store.state.shopNo);
          }
        }, 100);

        const timeoutId = setTimeout(() => {
          clearInterval(checkInterval);
          reject(new Error("shop_no not available within timeout"));
        }, timeout);
      });
    },
  },
};
